(() => {
  if (!/^fr(?:-|$)/i.test(document.documentElement.lang)) return;
  const labels = new Map(Object.entries({"Get $10":"Obtenir 10 $","PRODUCT REGISTRATION":"ENREGISTREMENT DU PRODUIT","First Name":"Prénom","Last Name":"Nom","Email":"E-mail","Country":"Pays","Please select":"Choisissez une option","Product Name":"Nom du produit","Order ID /#":"Numéro de commande","Amazon Review Link":"Lien vers votre avis Amazon","Please upload your review proof of Amazon.":"Ajoutez une copie de votre avis Amazon.","Choose file or drag here":"Choisissez un fichier ou déposez-le ici","Supported format: JPG, JPEG, PNG, GIF, SVG.":"Formats acceptés : JPG, JPEG, PNG, GIF, SVG.","Browse file":"Choisir un fichier","Submit":"Envoyer","Submitting...":"Envoi en cours…","Next":"Suivant","Previous":"Précédent","Back":"Retour","Remove":"Supprimer","Page 1":"Page 1","This field is required.":"Ce champ est obligatoire.","This field is required":"Ce champ est obligatoire.","Please enter a valid email address.":"Saisissez une adresse e-mail valide.","Please enter a valid email address":"Saisissez une adresse e-mail valide.","Please enter a valid URL.":"Saisissez une adresse web valide.","File is too large":"Le fichier est trop volumineux.","Thank you for your submission!":"Merci, votre formulaire a été envoyé !","Your submission has been received.":"Nous avons reçu votre formulaire."}
));
  const countries = new Map();
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z]/g, '');
  if (typeof Intl.DisplayNames === 'function') {
    const en = new Intl.DisplayNames(['en'], { type: 'region' });
    const de = new Intl.DisplayNames(['fr'], { type: 'region' });
    for (let a = 65; a <= 90; a++) for (let b = 65; b <= 90; b++) {
      const code = String.fromCharCode(a, b), name = en.of(code);
      if (name !== code) countries.set(normalize(name), de.of(code));
    }
    const aliases = {
      'Antigua And Barbuda': 'AG', 'Bosnia And Herzegovina': 'BA',
      'Czech Republic': 'CZ', 'Turkey': 'TR', 'Saint Lucia': 'LC',
      'Saint Kitts And Nevis': 'KN', 'Saint Pierre And Miquelon': 'PM',
      'Trinidad and Tobago': 'TT', 'Turks and Caicos Islands': 'TC',
      'Wallis And Futuna': 'WF', 'Côte d’Ivoire': 'CI',
      'Virgin Islands, British': 'VG', 'Republic of Cameroon': 'CM',
      'Congo, The Democratic Republic Of The': 'CD', 'Congo': 'CG',
      "Côte d'Ivoire": 'CI', 'Guinea Bissau': 'GW', 'Iran, Islamic Republic Of': 'IR',
      "Lao People's Democratic Republic": 'LA', 'Libyan Arab Jamahiriya': 'LY',
      'Macao': 'MO', 'Moldova, Republic of': 'MD', 'Korea, Democratic People\'s Republic Of': 'KP',
      'Palestinian Territory, Occupied': 'PS', 'Reunion': 'RE', 'St. Vincent': 'VC',
      'Tanzania, United Republic Of': 'TZ', 'Timor Leste': 'TL',
      'United States Minor Outlying Islands': 'UM', 'Holy See (Vatican City State)': 'VA',
      'Saint Martin': 'MF', 'Saint Helena': 'SH', 'Saint Barthélemy': 'BL',
      'Sao Tome And Principe': 'ST', 'Falkland Islands (Malvinas)': 'FK',
      'Heard Island And Mcdonald Islands': 'HM', 'Svalbard And Jan Mayen': 'SJ',
      'South Georgia And The South Sandwich Islands': 'GS', 'Netherlands Antilles': 'AN'
    };
    for (const [name, code] of Object.entries(aliases)) countries.set(normalize(name), de.of(code));
    countries.set(normalize('Netherlands Antilles'), 'Antilles néerlandaises');
  }
  const translate = root => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (const node of nodes) {
      if (node.parentElement?.closest('script, style, textarea, [contenteditable="true"]')) continue;
      const value = node.nodeValue.trim(), replacement = labels.get(value);
      if (replacement) node.nodeValue = node.nodeValue.replace(value, replacement);
    }
    for (const element of root.querySelectorAll('[placeholder], [aria-label]')) {
      for (const attr of ['placeholder', 'aria-label']) {
        const replacement = labels.get(element.getAttribute(attr));
        if (replacement) element.setAttribute(attr, replacement);
      }
    }
    for (const option of root.querySelectorAll('select option[value]')) {
      const replacement = countries.get(normalize(option.value));
      if (replacement && option.textContent !== replacement) option.textContent = replacement;
    }
  };
  let scheduled = false;
  const scan = () => {
    scheduled = false;
    document.querySelectorAll('.globo-formbuilder, #loox-visitor-level-referral-btn').forEach(translate);
  };
  const schedule = () => {
    if (!scheduled) { scheduled = true; requestAnimationFrame(scan); }
  };
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  scan();
})();